import { useEffect, useRef, useState } from 'react';
import { Globe, Network, Rocket, Search, Users, FileText } from 'lucide-react';
import whyUseCover from '@/assets/landing/images/why-use-cover.png';

const features = [
  {
    icon: Search,
    title: 'Antecipe tendências',
    description: 'Esteja à frente da concorrência com insights culturais em tempo real.'
  },
  {
    icon: Globe,
    title: 'Entenda o Brasil real',
    description: 'Profundidade cultural com leitura regional feita por humanos e analisada por AI.'
  },
  {
    icon: FileText,
    title: 'Impulsione o alcance orgânico',
    description: 'Conecte sua marca com as conversas em alta e conquiste uma maior audiência orgânica.'
  },
  {
    icon: Users,
    title: 'Ative criadores em alta',
    description: 'Encontre os influenciadores ideais em diferentes regiões e comunidades para cada oportunidade.'
  },
  {
    icon: Rocket,
    title: 'Ganhe agilidade na sua marca',
    description: 'Insights acionáveis para seu time de marketing implementar todos os dias.'
  },
  {
    icon: Network,
    title: 'Evolua seu modelo de governança',
    description: 'Integre times de marketing e agência em sprints diários de aprovação de conteúdo.'
  }
];

export default function WhyUseSection() {
  const [visibleCards, setVisibleCards] = useState<number[]>([]);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            features.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => [...prev, index]);
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-24">
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${whyUseCover})` }}></div>
      <div className="relative z-10">
        <div className="landing-container">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 font-['Times_New_Roman']">Por que usar?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              O Culture Monitor é a escolha certa para profissionais que precisam transformar cultura em ação criativa.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div
                  key={index}
                  className={`bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-700 ${
                    visibleCards.includes(index) ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'
                  }`}
                >
                  <div className="w-12 h-12 bg-[#F2FF00] rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

